<div class="container py-4">

  <!-- 🔷 TÍTULO -->
  <h2 class="titulo">INGENIERÍA EN INTELIGENCIA ARTIFICIAL</h2>

  <!-- 🟥 BANNER -->
  <div class="banner-ia">
    <div class="banner-left">
      <img src="assets/banners_carreras/SISTEMASCOM.jpg" alt="IA">
    </div>
  </div>

  <!-- 📘 INFO PRINCIPAL -->
  <section class="info-section">

    <div class="info-block">
      <h3>■ OBJETIVO GENERAL</h3>
      <p>
        Formar ingenieros competentes en el diseño, desarrollo, y evaluación de sistemas inteligentes para la toma de decisiones en entornos industriales, empresariales y de investigación que contribuyan al avance de las ciencias humanísticas y tecnológicas, con un enfoque multidisciplinario, ético y sostenible.
      </p>
    </div>

  </section>

  <!-- 🧠 TABS -->
  <div class="tabs-box">

    <ul class="nav nav-tabs">
      <li class="nav-item">
        <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#tab1">
          1. Perfil de Ingreso
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2">
          2. Perfil de Egreso
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab3">
          3. Atributos de Egreso
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab4">
          4. Información del Personal
        </button>
      </li>
    </ul>

    <div class="tab-content">

      <!-- TAB 1 -->
      <div id="tab1" class="tab-pane fade show active">
        <ul>
          <li>Habilidades lógico-matemáticas.</li>
          <li>Habilidades en tecnología y ciencia de la computación</li>
          <li>Capacidad creativa, analítica y emprendedora</li>
          <li>Liderazgo y capacidad de trabajo en equipo. </li>
          <li>Capacidad para el diseño y la innovación en la tecnología. </li>
          <li>Conciencia ética y social</li>
          <li>Compromiso con el desarrollo sostenible</li>
        </ul>
      </div>

      <!-- TAB 2 -->
      <div id="tab2" class="tab-pane fade">
        <ul>
          <li>•	Utiliza análisis de datos, herramientas y técnicas avanzadas de inteligencia artificial para resolver problemas complejos en diferentes entornos sociales.</li>
          <li>•	Diseña, evalúa y modela algoritmos para crear soluciones inteligentes en entornos industriales, empresariales y de investigación en una o varias áreas funcionales, cumpliendo con estándares de calidad y ética</li>
          <li>•	Aplica principios teóricos y prácticos para el análisis y desarrollo de sistemas inteligentes con sentido humano.</li>
          <li>•	Desarrolla soluciones en inteligencia artificial para integrar sistemas completos que automatizan procesos, optimizan operaciones y mejoran la toma de decisiones en sectores industriales y comerciales con responsabilidad social.</li>
          <li>•	Contribuye a la generación, comunicación y difusión de conocimiento en el campo de la inteligencia artificial mediante la participación en proyectos multidisciplinarios para la gestión de proyectos de desarrollo tecnológico en su entorno.</li>
        </ul>
      </div>

      <!-- TAB 3 -->
      <div id="tab3" class="tab-pane fade">
        <ul>
          <li>Contenido pendiente...</li>
        </ul>
      </div>

      <!-- TAB 4 -->
      <div id="tab4" class="tab-pane fade">
        <h5>Personal Responsable</h5>
        <p><strong>Nombre:</strong> Ing. Manuel de Atocha Barrancos Martínez</p>
        <p><strong>Correo:</strong> divisionisc@itsescarcega.edu.mx</p>
      </div>

    </div>
  </div>

  <!--DOCUMENTACIÓN -->
  <div class="doc-section text-center">
    <img src="assets/banners_carreras/logo_drive.png" class="doc-icon">
    <br>
    <a href="https://drive.google.com/drive/folders/1welJwNCT2WNm_e9kNHil_KWBivfYhwld" 
       target="_blank" 
       class="doc-link">
       ■ DOCUMENTACIÓN INGENIERÍA EN INTELIGENCIA ARTIFICIAL
    </a>
  </div>

  <hr>


  <div class="btn-section">

    <a href="assets/reticulas/Retícula Inteligencia Artificial.pdf" target="_blank" class="btn-doc">
      📊 Retícula
    </a>
  </div>

  <!-- 👤 CONTACTO (AL FINAL 🔥) -->
  <section class="contact-section">

    <div class="contact-row">

      <div class="contact-card">
        <h3>■ JEFE DE DIVISIÓN</h3>
        <p class="name">Ing. Manuel de Atocha Barrancos Martínez</p>
        <p>E-mail: <a href="mailto:divisionisc@itsescarcega.edu.mx">divisionisc@itsescarcega.edu.mx</a></p>
        <P> Telefono:9821175184 </P>
      </div>

      <div class="contact-card">
        <h3>■ COORDINADORA</h3>
        <p class="name">Lic. Jazmín Solis Rebolledo</p>
        <p>E-mail: <a href="mailto:coordinacionisc@itsescarcega.edu.mx">coordinacionisc@itsescarcega.edu.mx</a></p>
        <p> Telefono:9821047765</p>
      </div>

    </div>

  </section>

</div>